module.exports = __webpack_public_path__ + "static/media/activity.b0fe1566.svg";